import { Bounds, Coord } from "../../../../../../../../src/types/Interface";


export default function getSnap(bounds: Bounds, ceilSize: number, coord: Coord) {
  const hOfCeilSize = ceilSize / 2;

  const gridStartCoord = {
    x: bounds.x - (bounds.width / 2),
    y: bounds.y - (bounds.height / 2)
  };

  const gridEndCoord = {
    x: bounds.x + (bounds.width / 2),
    y: bounds.y + (bounds.height / 2)
  }
  
  const _x = Math.max(Math.min(gridEndCoord.x, coord.x), gridStartCoord.x);
  const _y = Math.max(Math.min(gridEndCoord.y, coord.y), gridStartCoord.y);

  const x = Math.round((_x - bounds.x) / hOfCeilSize) * hOfCeilSize + bounds.x;
  const y = Math.round((_y - bounds.y) / hOfCeilSize) * hOfCeilSize + bounds.y;

  return { x, y }
}

